import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import InvestigationAppealModal from 'Components/Modals/InvestigationAppealModal';
import Button from 'Components/UI/Button';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(1),
  },
  bottomButtons: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(4),
  },
});

const View = ({
  classes, onClickAppeal, onClickReject, onClickAccept, onClose, onSubmit, modalProps, amplitudeRootNodeProps,
}) => {
  return (
    <Box className={classes.root} {...amplitudeRootNodeProps}>
      {modalProps.show && (
        <InvestigationAppealModal
          defaultText={modalProps.defaultText}
          prompt={modalProps.prompt}
          isLoading={modalProps.isLoading}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      )}
      <Box className={classes.bottomButtons}>
        {onClickAppeal && (
        <Button
          className={classes.button}
          onClick={onClickAppeal}
          variant="contained"
          color="grey"
        >
          Appeal
        </Button>
        )}
        {onClickAccept && (
        <Button
          className={classes.button}
          onClick={onClickAccept}
          variant="contained"
          color="secondary"
        >
              Accept
        </Button>
        )}
        {onClickReject && (
        <Button
          className={classes.button}
          onClick={onClickReject}
          variant="contained"
          color="red"
        >
              Reject
        </Button>
        )}
      </Box>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object,
  onClickAppeal: PropTypes.func,
  onClickAccept: PropTypes.func,
  onClickReject: PropTypes.func,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  modalProps: PropTypes.object,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
};

View.defaultProps = {
  classes: {},
  onClickAppeal: () => {},
  onClickAccept: () => {},
  onClickReject: () => {},
  onClose: () => {},
  onSubmit: () => {},
  modalProps: {},
};

export default withStyles(styles)(View);
